const state = {
   incomingCargo:{},
}

export default state
